import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import DestinationSection from "../pages/DestinationSection";
import homesec from "../assets/images/homesec.webp";
import HotelBooking from "../pages/HotelBooking";

import voyagenewbanner from "../assets/images/voyagenewbanner.webp";
import banner1 from "../assets/images/banner1.webp";
import banner1mobile from "../assets/images/banner1mobile.webp";
import newimage from "../assets/images/newimage.png";
import banner3 from "../assets/images/banner3.webp";
import banner3mobile from "../assets/images/banner3mobile.webp";
import newimagemobile from "../assets/images/newimagemobile.webp";
import banner5 from "../assets/images/banner5.webp";
import banner5mobile from "../assets/images/banner5mobile.webp";

import Whyvoyage from "../pages/Whyvoyage";
import AboutVoyage from "../pages/Aboutvoyage";
import TransferSection from "../pages/TransferSection";
import voyagemobile from "../assets/images/voyagemobile.webp";
import AirlinesSlider from "../pages/AirlinesSlider";
import Insurance from "../pages/Insurance";
import VisaSection from "../pages/VisaSection";
import HotDealsSection from "../pages/HotDealsSection";
import VoyageSection from "../pages/VoyageSection";

// ============================================================
// PREVIOUS ARROW
// ============================================================

const PrevArrow = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Previous slide"
    className="
      absolute left-5 top-1/2 z-40
      flex h-11 w-11
      -translate-y-1/2
      items-center justify-center
      rounded-full
      border border-white/30
      bg-black/20
      text-white
      backdrop-blur-md
      transition-all duration-300
      hover:scale-105
      hover:border-[#97BF49]
      hover:bg-[#97BF49]
      md:left-6
    "
  >
    <i className="las la-angle-left text-xl" />
  </button>
);

// ============================================================
// NEXT ARROW
// ============================================================

const NextArrow = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Next slide"
    className="
      absolute right-5 top-1/2 z-40
      flex h-11 w-11
      -translate-y-1/2
      items-center justify-center
      rounded-full
      border border-white/30
      bg-black/20
      text-white
      backdrop-blur-md
      transition-all duration-300
      hover:scale-105
      hover:border-[#97BF49]
      hover:bg-[#97BF49]
      md:right-6
    "
  >
    <i className="las la-angle-right text-xl" />
  </button>
);

function Home() {
  // ==========================================================
  // SERVICES
  // ==========================================================

  const services = [
    {
      id: "tour-packages",
      name: "Tour Packages",
      icon: "la-map-marked-alt",
      color: "blue",
      description: "Discover unforgettable places",
    },
    {
      id: "flights",
      name: "Flights",
      icon: "la-plane",
       color: "green",
      description: "Find your perfect flight",
    },
    {
      id: "hotels",
      name: "Hotels",
      icon: "la-hotel",
      color: "blue",
      description: "Stay somewhere beautiful",
    },
    
    {
      id: "visa",
      name: "Visa",
      icon: "la-passport",
      color: "green",
      description: "Travel without the stress",
    },
    {
      id: "transfer",
      name: "Transfer",
      icon: "la-shuttle-van",
      color: "blue",
      description: "Arrive in comfort and convenience",
    },
    {
      id: "insurance",
      name: "Insurance",
      icon: "la-shield-alt",
      color: "green",
      description: "Travel with confidence",
    },
    {
      id: "b2b",
      name: "B2B",
      icon: "la-users",
      color: "blue",
      description: "Travel business partnerships",
      
    },
  ];

  const iconStyles = {
    blue: {
      bg: "from-[#019EE7] to-[#007FC0]",
      soft: "bg-[#9BC5E0]/40",
      text: "text-[#019EE7]",
      glow: "group-hover:shadow-[#019EE7]/30",
    },

    green: {
      bg: "from-[#97BF49] to-[#759F2F]",
      soft: "bg-[#97BF49]/20",
      text: "text-[#759F2F]",
      glow: "group-hover:shadow-[#97BF49]/30",
    },
  };

  const heroSlides = [
    {
      desktop: voyagenewbanner,
      mobile: voyagemobile,
      icon: "la-map-marker",
      smallText: "WELCOME TO VOYAGE Plus",
      title: (
    <>
      Big Attention <br /> to Details
    </>
  ),
      description:
        "Access airline bookings, hotels, holiday packages, and travel solutions through one seamless and user-friendly online booking platform.",
      accent: "#A8D438",
      titleColor: "#FFFFFF",
      eyebrowColor: "#FFFFFF",
      descriptionColor: "#FFFFFF",
      overlay: "bg-black/[0.02]",
      textShadow: true,
    },

    {
      desktop: banner5,
      mobile: banner5mobile,
      icon: "la-plane",
      smallText: "AIRLINE BOOKING & TICKETING",
      title: "Your Journey Starts with the Right Flight",
      description:
        "Access airline booking and ticketing services through Voyage Plus and manage your flight requirements efficiently from one convenient platform.",
      accent: "#0050a1",
      titleColor: "#0050a1",
      eyebrowColor: "#263C42",
      descriptionColor: "#263238",
      overlay: "bg-white/[0.02]",
      textShadow: false,
    },

    {
      desktop: banner3,
      mobile: banner3mobile,
      icon: "la-hotel",
      smallText: "HOTEL RESERVATIONS MADE SIMPLE",
      title: "The Right Stay for Every Journey",
      description:
        "Manage hotel reservations through Voyage Plus as part of your complete travel requirements—all conveniently accessible from a single portal.",
      accent: "#0050a1",
      titleColor: "#0050a1",
      eyebrowColor: "#263C42",
      descriptionColor: "#263238",
      overlay: "bg-white/[0.02]",
      textShadow: false,
    },

    {
      desktop: banner1,
      mobile: banner1mobile,
      icon: "la-map-marked-alt",
      smallText: "HOLIDAY PACKAGES THROUGH VOYAGE Plus",
      title: "More Destinations More Experiences",
      description:
        "Access holiday packages and other travel-related solutions through a seamless platform designed to make travel planning simple and efficient.",
      accent: "#0050a1",
      titleColor: "#0050a1",
      eyebrowColor: "#263C42",

      descriptionColor: "#263238",

      overlay: "bg-white/[0.02]",

      textShadow: false,
    },

    {
      desktop: newimage,
      mobile: newimagemobile,

      icon: "la-globe",

      smallText: "EVERYTHING YOU NEED, ALL IN ONE PLACE",

      title: "One Portal Complete Travel Solutions",

      description:
        "From airline bookings and hotel reservations to holiday packages and other travel services, Voyage Plus helps authorized users manage their travel requirements through a single platform.",

      accent: "#0050a1",

      titleColor: "#0050a1",

      eyebrowColor: "#263C42",

      descriptionColor: "#263238",

      overlay: "bg-white/[0.02]",

      textShadow: false,
    },
  ];

  const sliderSettings = {
    dots: true,
    arrows: false,

    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,

    infinite: true,

    speed: 900,

    slidesToShow: 1,
    slidesToScroll: 1,

    autoplay: true,
    autoplaySpeed: 5000,

    pauseOnHover: false,
    pauseOnFocus: false,

    fade: true,

    cssEase: "ease-in-out",

    adaptiveHeight: false,
  };

  return (
    <>
      {/* ======================================================
          DESKTOP HERO
      ====================================================== */}

      <section
        className="
          relative
          -mt-6
          hidden
          min-h-[690px]
          overflow-hidden
          md:block
        "
      >
        <Slider {...sliderSettings} className="voyage-hero-slider">
          {heroSlides.map((slide, index) => (
            <div key={index} target="_blank">
              <div
                className="relative min-h-[600px] overflow-hidden bg-contain bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url(${slide.desktop})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              >
                {/* <div className={`absolute inset-0 ${slide.overlay}`} /> */}

                <div className="relative z-10 mx-auto flex min-h-[690px] max-w-7xl items-center px-6 pt-16 lg:px-8">
                  <div className="w-full">
                    <div className="max-w-[620px] pb-2">
                      <div className="mb-5 flex items-center gap-3">
                        <i
                          className={`las ${slide.icon} text-[22px] xl:text-[24px]`}
                          style={{
                            color: slide.accent,
                            filter: `drop-shadow(0 2px 5px ${slide.accent}55)`,
                          }}
                        />

                        <span
                          className="text-[12px] font-bold uppercase tracking-[2px] sm:text-[13px] md:text-[14px] xl:text-[15px]"
                          style={{
                            color: slide.eyebrowColor,
                            textShadow: slide.textShadow
                              ? "0 2px 8px rgba(0,0,0,0.25)"
                              : "0 1px 5px rgba(255,255,255,0.35)",
                          }}
                        >
                          {slide.smallText}
                        </span>
                      </div>

                      <h1
                        className="max-w-[650px] text-[54px] font-black leading-[0.98] tracking-[-2px] sm:text-[62px] md:text-[60px] lg:text-[66px] xl:text-[62px]"
                        style={{
                          color: slide.titleColor,
                          textShadow: slide.textShadow
                            ? "0 4px 18px rgba(0,0,0,0.32)"
                            : "0 2px 10px rgba(255,255,255,0.30)",
                        }}
                      >
                        {slide.title}
                      </h1>

                      {/* =================================================
                  ACCENT LINE
              ================================================= */}

                      <div
                        className="mt-5 h-[3px] w-[48px] rounded-full"
                        style={{
                          backgroundColor: slide.accent,
                          boxShadow: `0 2px 10px ${slide.accent}66`,
                        }}
                      />

                      <p
                        className="mt-5 max-w-[560px] text-[15px] font-medium leading-[1.65] sm:text-[16px] md:text-[17px] xl:text-[18px]"
                        style={{
                          color: slide.descriptionColor,
                          textShadow: slide.textShadow
                            ? "0 2px 8px rgba(0,0,0,0.25)"
                            : "0 1px 4px rgba(255,255,255,0.30)",
                        }}
                      >
                        {slide.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>

      {/* ======================================================
          MOBILE HERO
      ====================================================== */}

      <section
        className="
          relative
          -mt-6
          block
          min-h-[580px]
          overflow-hidden
          md:hidden
        "
      >
        <Slider {...sliderSettings} className="voyage-mobile-slider">
          {heroSlides.map((slide, index) => (
            <div key={index}>
              <div
                className="
                  relative
                  min-h-[580px]
                  overflow-hidden
                  bg-cover
                  bg-center
                  bg-no-repeat
                "
                style={{
                  backgroundImage: `url(${slide.mobile})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "top",
                }}
              >
                {/* =================================================
                    MOBILE OVERLAY
                ================================================= */}

                <div className={`absolute inset-0 ${slide.overlay}`} />

                {/* =================================================
                    MOBILE CONTENT
                ================================================= */}

                <div
                  className="
                    relative
                    z-10
                    flex
                    min-h-[520px]
                    items-center
                    px-6
                    pt-6
                  "
                >
                  <div className="w-full">
                    <div className="max-w-[340px]">
                      {/* =================================================
                          MOBILE EYEBROW
                      ================================================= */}

                      <div
                        className="
                          mb-4
                          flex
                          items-center
                          gap-2.5
                        "
                      >
                        <i
                          className={`
                            las
                            ${slide.icon}
                            text-[18px]
                          `}
                          style={{
                            color: slide.accent,
                          }}
                        />

                        <span
                          className="
                            text-[9px]
                            font-bold
                            uppercase
                            leading-5
                            tracking-[1.1px]
                          "
                          style={{
                            color: slide.eyebrowColor,
                            textShadow: slide.textShadow
                              ? "0 2px 6px rgba(0,0,0,0.25)"
                              : "0 1px 4px rgba(255,255,255,0.30)",
                          }}
                        >
                          {slide.smallText}
                        </span>
                      </div>

                      {/* =================================================
                          MOBILE TITLE
                      ================================================= */}

                      <h1
                        className="
                          max-w-[335px]
                          text-[32px]
                          font-black
                          leading-[0.98]
                          tracking-[-1.3px]
                          sm:text-[46px]
                        "
                        style={{
                          color: slide.titleColor,

                          textShadow: slide.textShadow
                            ? "0 3px 12px rgba(0,0,0,0.30)"
                            : "0 2px 8px rgba(255,255,255,0.30)",
                        }}
                      >
                        {slide.title}
                      </h1>

                      {/* =================================================
                          MOBILE ACCENT LINE
                      ================================================= */}

                      <div
                        className="
                          mt-4
                          h-[2px]
                          w-[34px]
                          rounded-full
                        "
                        style={{
                          backgroundColor: slide.accent,
                          boxShadow: `0 2px 7px ${slide.accent}66`,
                        }}
                      />

                      {/* =================================================
                          MOBILE DESCRIPTION
                      ================================================= */}

                      <p
                        className="
                          mt-4
                          max-w-[315px]
                          text-[13px]
                          font-medium
                          leading-[1.6]
                        "
                        style={{
                          color: slide.descriptionColor,

                          textShadow: slide.textShadow
                            ? "0 2px 6px rgba(0,0,0,0.25)"
                            : "0 1px 3px rgba(255,255,255,0.25)",
                        }}
                      >
                        {slide.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </section>

      {/* ======================================================
          SERVICES
      ====================================================== */}

      <section className="relative z-30 mx-auto max-w-7xl px-4 sm:px-5">
        <div
          className="
            relative
            -mt-[40px]
            overflow-hidden
            rounded-xl
            border
            border-[#9BC5E0]/40
            bg-[#fff]
            shadow-[0_30px_80px_rgba(18,52,74,0.18)]
            md:-mt-[30px]
          "
        >
          <div
            className="
              relative
              grid
              grid-cols-2
              md:grid-cols-3
              lg:grid-cols-7
            "
          >
            {services.map((service, index) => {
              const style = iconStyles[service.color];

              return (
                <a
                  href={service.href}
                  target="_blank"
                  key={service.id}
                  onClick={() =>
                    document.getElementById(service.id)?.scrollIntoView({
                      behavior: "smooth",
                    })
                  }
                  className="
                    group
                    relative
                    flex
                    min-h-[135px]
                    cursor-pointer
                    flex-col
                    items-center
                    justify-center
                    px-2
                    py-2
                    transition-all
                    duration-500
                    hover:bg-[#9BC5E0]/10
                    sm:min-h-[180px]
                    sm:px-3
                    sm:py-6
                    md:min-h-[140px]
                    md:px-4
                    md:py-3
                  "
                >
                  {index !== 0 && (
                    <div
                      className="
                        absolute
                        bottom-10
                        left-0
                        top-10
                        hidden
                        w-px
                        bg-gradient-to-b
                        from-transparent
                        via-[#9BC5E0]/50
                        to-transparent
                        lg:block
                      "
                    />
                  )}

                  {index % 2 !== 0 && (
                    <div
                      className="
                        absolute
                        bottom-6
                        left-0
                        top-6
                        w-px
                        bg-[#9BC5E0]/30
                        lg:hidden
                        sm:bottom-8
                        sm:top-8
                      "
                    />
                  )}

                  <div className="relative">
                    <div
                      className={`
                        absolute
                        inset-0
                        scale-75
                        rounded-full
                        opacity-0
                        blur-2xl
                        transition-all
                        duration-500
                        group-hover:scale-125
                        group-hover:opacity-70
                        ${style.soft}
                      `}
                    />

                    <div
                      className="
                        relative
                        flex
                        h-[62px]
                        w-[62px]
                        items-center
                        justify-center
                        rounded-full
                        border
                        border-[#9BC5E0]/50
                        bg-[#FEFEFE]
                        shadow-[0_10px_30px_rgba(18,52,74,0.10)]
                        transition-all
                        duration-500
                        group-hover:scale-110
                        group-hover:border-transparent
                        sm:h-[70px]
                        sm:w-[70px]
                        md:h-[58px]
                        md:w-[58px]
                      "
                    >
                      <div
                        className={`
                          relative
                          flex
                          h-[50px]
                          w-[50px]
                          items-center
                          justify-center
                          rounded-full
                          bg-gradient-to-br
                          shadow-lg
                          transition-all
                          duration-500
                          sm:h-[56px]
                          sm:w-[56px]
                          md:h-[46px]
                          md:w-[46px]
                          ${style.bg}
                          ${style.glow}
                        `}
                      >
                        <span
                          className="
                            absolute
                            left-[7px]
                            top-[6px]
                            h-[6px]
                            w-[17px]
                            rotate-[-25deg]
                            rounded-full
                            bg-[#FEFEFE]/50
                            blur-[1px]
                            sm:left-[8px]
                            sm:top-[6px]
                            sm:h-[7px]
                            sm:w-[19px]
                            md:left-[10px]
                            md:top-[7px]
                            md:h-[8px]
                            md:w-[22px]
                          "
                        />

                        <i
                          className={`
                            las
                            ${service.icon}
                            relative
                            text-[24px]
                            text-[#FEFEFE]
                            sm:text-[27px]
                            md:text-[26px]
                          `}
                        />
                      </div>
                    </div>
                  </div>

                  <h4
                    className="
                      mt-2
                      text-center
                      text-[12px]
                      font-extrabold
                      uppercase
                      leading-4
                      text-[#12344A]
                      transition-colors
                      duration-300
                      group-hover:text-[#019EE7]
                      sm:mt-2
                      sm:text-[14px]
                      sm:leading-5
                      md:text-base
                    "
                  >
                    {service.name}
                  </h4>

                  <div
                    className="
                      absolute
                      bottom-0
                      left-1/2
                      h-[3px]
                      w-0
                      -translate-x-1/2
                      rounded-full
                      bg-gradient-to-r
                      from-[#019EE7]
                      to-[#97BF49]
                      transition-all
                      duration-500
                      group-hover:w-12
                    "
                  />
                </a>
              );
            })}
          </div>
        </div>
      </section>
      <section>
        <AboutVoyage />
      </section>
      <section
        className="pb-12"
        style={{
          backgroundImage: `url(${homesec})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
        }}
      >
        <DestinationSection />
      </section>
      <section>
        <AirlinesSlider />
      </section>
      <section id="hotels" className="md:scroll-mt-32">
        <HotelBooking />
      </section>
      <section>
        <HotDealsSection />
      </section>
      <section>
        <Whyvoyage />
      </section>
      <section className="">
        <VisaSection />
      </section>
      <section id="transfer" className="">
        <TransferSection />
      </section>
      <section>
        <Insurance />
      </section>
      <section className="md:px-0 px-4 md:pb-0 pb-12">
        <VoyageSection/>
      </section>
    </>
  );
}

export default Home;
